// extracted by mini-css-extract-plugin
module.exports = {"progress":"styles_progress__3Kyh4","progressDone":"styles_progressDone__q9sIE","appearing":"styles_appearing__2Ey_d","text":"styles_text__aVkHw"};